import { makeActions } from 'redux/crudCreator/actions';

export const MODEL_NAME = 'niches';
export const nichesActions = makeActions(MODEL_NAME);

export const getAllNiches = nichesActions.getAll;
export const editNiches = nichesActions.edit;
export const createNiches = nichesActions.create;
export const getByIdNiches = nichesActions.getDataById;

